var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-info"},[_c('div',{staticClass:"img_block"}),_c('div',{staticClass:"info_block"},[_c('p',[_vm._v(_vm._s(_vm.content.name))]),_c('download-file',{staticClass:"download-file",attrs:{"dataFile":{url: _vm.content.url, size: _vm.content.size, type: _vm.content.type}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }